(function () {
  'use strict';
  if (window.HolyFooterV4) { window.HolyFooterV4.init(document); return; }
  var API = 'https://api.holyfoods.com.br/functions/v1/lead-capture';
  var mobile = window.matchMedia('(max-width:768px)');
  function sizeMenus() {
    document.querySelectorAll('[data-hf-footer] details').forEach(function (item) {
      item.open = !mobile.matches;
      item.querySelector('summary').tabIndex = mobile.matches ? 0 : -1;
    });
  }
  mobile.addEventListener('change', sizeMenus);
  function phoneBR(value) {
    var digits = value.replace(/\D/g, '');
    if ((digits.length === 12 || digits.length === 13) && digits.slice(0, 2) === '55') digits = digits.slice(2);
    var ddds = '11 12 13 14 15 16 17 18 19 21 22 24 27 28 31 32 33 34 35 37 38 41 42 43 44 45 46 47 48 49 51 53 54 55 61 62 63 64 65 66 67 68 69 71 73 74 75 77 79 81 82 83 84 85 86 87 88 89 91 92 93 94 95 96 97 98 99'.split(' ');
    return /^\d{2}9\d{8}$/.test(digits) && ddds.indexOf(digits.slice(0, 2)) !== -1 ? '+55' + digits : null;
  }
  function formatPhone(value) {
    var digits = value.replace(/\D/g, '');
    if (digits.length > 11 && digits.slice(0, 2) === '55') digits = digits.slice(2);
    digits = digits.slice(0, 11);
    if (digits.length <= 2) return digits;
    return '(' + digits.slice(0, 2) + ') ' + digits.slice(2, 7) + (digits.length > 7 ? '-' + digits.slice(7) : '');
  }
  function emailSuggestion(value) {
    var parts = value.trim().split('@');
    if (parts.length !== 2 || !parts[0]) return '';
    var typo = {'gmai.com':'gmail.com','gmil.com':'gmail.com','gmal.com':'gmail.com','gamil.com':'gmail.com','gnail.com':'gmail.com','gmail.con':'gmail.com','gmail.com.br':'gmail.com','hotmai.com':'hotmail.com','hotmal.com':'hotmail.com','hotmial.com':'hotmail.com','hotmail.con':'hotmail.com','outlok.com':'outlook.com','outlook.con':'outlook.com','yaho.com':'yahoo.com','yahoo.con':'yahoo.com','icloud.con':'icloud.com'};
    return typo[parts[1].toLowerCase()] ? parts[0] + '@' + typo[parts[1].toLowerCase()] : '';
  }
  async function request(url, options, timeout) {
    var controller = new AbortController();
    var timer;
    try {
      return await Promise.race([
        (async function () {
          var response = await fetch(url, Object.assign({}, options, { signal: controller.signal }));
          return { response: response, data: await response.json() };
        })(),
        new Promise(function (_, reject) { timer = setTimeout(function () { controller.abort(); var error = new Error('Timeout'); error.name = 'AbortError'; reject(error); }, timeout); })
      ]);
    } finally { clearTimeout(timer); }
  }
  function loadReputation(reputation) {
    if (!reputation || !reputation.dataset.raId || reputation.dataset.raLoaded) return;
    reputation.dataset.raLoaded = 'true';
    var previous = document.getElementById('ra-embed-reputation');
    if (previous) previous.remove();
    var script = document.createElement('script');
    script.id = 'ra-embed-reputation'; script.async = true;
    script.src = 'https://s3.amazonaws.com/raichu-beta/selos/bundle.js';
    script.dataset.id = reputation.dataset.raId;
    script.dataset.target = reputation.id; script.dataset.model = '2';
    reputation.appendChild(script);
  }
  function prepareReputation(reputation) {
    if (!reputation || !reputation.dataset.raId || reputation.dataset.raObserved) return;
    reputation.dataset.raObserved = 'true';
    if (!('IntersectionObserver' in window)) { loadReputation(reputation); return; }
    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      loadReputation(reputation);
    }, { rootMargin: '600px 0px' });
    observer.observe(reputation);
  }
  function init(scope) {
    scope.querySelectorAll('[data-hf-footer]').forEach(function (footer) {
      if (footer.dataset.initialized) return;
      footer.dataset.initialized = 'true';
      footer.querySelectorAll('details').forEach(function (item) {
        item.open = !mobile.matches;
        var summary = item.querySelector('summary');
        summary.tabIndex = mobile.matches ? 0 : -1;
        summary.addEventListener('click', function (event) { if (!mobile.matches) event.preventDefault(); });
      });
      var form = footer.querySelector('form');
      if (form) {
        if (!form.dataset.crmSlug) {
          form.querySelector('button[type="submit"]').disabled = true;
          form.querySelector('[role="status"]').textContent = 'Cadastro disponível em breve.';
        }
        var phone = form.elements.phone;
        var email = form.elements.email;
        var hint = form.querySelector('[data-hf-email-hint]');
        var suggestionButton = form.querySelector('[data-hf-email-correction]');
        var suggestion = '';
        function checkEmail() {
          suggestion = emailSuggestion(email.value);
          if (hint && suggestionButton) { hint.hidden = !suggestion; suggestionButton.textContent = suggestion; }
        }
        email.addEventListener('blur', checkEmail);
        email.addEventListener('input', function () { if (hint) hint.hidden = true; });
        if (suggestionButton) suggestionButton.addEventListener('click', function () { email.value = suggestion; checkEmail(); email.focus(); });
        phone.addEventListener('input', function () { phone.value = formatPhone(phone.value); phone.setCustomValidity(''); phone.removeAttribute('aria-invalid'); });
        phone.addEventListener('blur', function () {
          phone.value = formatPhone(phone.value);
          phone.setCustomValidity(phone.value && !phoneBR(phone.value) ? 'Informe um celular com DDD e 9 dígitos. Exemplo: (11) 91234-5678.' : '');
          phone.setAttribute('aria-invalid', phone.value && !phoneBR(phone.value) ? 'true' : 'false');
        });
        var submitting = false;
        form.addEventListener('submit', async function (event) {
          event.preventDefault();
          if (submitting) return;
          email.value = email.value.trim();
          phone.value = formatPhone(phone.value);
          phone.setCustomValidity(phoneBR(phone.value) ? '' : 'Informe um celular com DDD e 9 dígitos. Exemplo: (11) 91234-5678.');
          checkEmail();
          if (!form.reportValidity() || !form.elements.consent.checked) return;
          var normalized = phoneBR(phone.value);
          if (!normalized) { phone.setCustomValidity('Informe um celular com DDD e 9 dígitos. Exemplo: (11) 91234-5678.'); phone.reportValidity(); return; }
          var status = form.querySelector('[role="status"]');
          var button = form.querySelector('button[type="submit"]');
          if (!form.dataset.crmSlug) { status.textContent = 'O cadastro estará disponível em breve. Tente novamente mais tarde.'; return; }
          button.disabled = true;
          submitting = true;
          form.setAttribute('aria-busy', 'true');
          status.textContent = 'Enviando seu cadastro…';
          var sent = false;
          try {
            // Require the server's capture-only contract before any personal data
            // is submitted. Legacy lead forms can create coupons automatically.
            var configuration;
            try { configuration = await request(API + '?slug=' + encodeURIComponent(form.dataset.crmSlug), {}, 10000); }
            catch (_) { configuration = await request(API + '?slug=' + encodeURIComponent(form.dataset.crmSlug), {}, 10000); }
            if (!configuration.response.ok || configuration.data.capture_mode !== 'newsletter') throw new Error('A newsletter está temporariamente indisponível. Tente novamente mais tarde.');
            sent = true;
            var capture = await request(API, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ slug: form.dataset.crmSlug, email: form.elements.email.value.trim(), phone: normalized, website: form.elements.website.value, consent: form.elements.consent.checked, source: 'rodape-site' })
            }, 30000);
            var result = capture.data;
            if (!capture.response.ok || result.ok !== true || result.error) throw new Error('Não foi possível concluir o cadastro. Confira os dados e tente novamente.');
            status.textContent = '';
            var successTitle = document.createElement('strong');
            successTitle.textContent = '✓ ' + (form.dataset.successTitle || 'Cadastro confirmado');
            var successMessage = document.createElement('span');
            successMessage.textContent = result.optin_blocked ? 'Cadastro recebido. Suas preferências anteriores de comunicação foram preservadas.' : form.dataset.success;
            status.appendChild(successTitle);
            status.appendChild(successMessage);
            form.dataset.state = 'success';
            status.tabIndex = -1;
            status.focus({ preventScroll: true });
            form.reset();
            if (hint) hint.hidden = true;
          } catch (error) {
            status.textContent = error.name === 'AbortError' || error instanceof TypeError ? (sent ? 'Não recebemos a confirmação do cadastro. Seus dados continuam aqui para você tentar novamente.' : 'Não conseguimos conectar agora. Seus dados continuam aqui para você tentar novamente.') : (error.message || 'Não foi possível concluir o cadastro. Tente novamente.');
          } finally { button.disabled = false; submitting = false; form.removeAttribute('aria-busy'); }
        });
      }
      var reputation = footer.querySelector('[data-ra-id]');
      prepareReputation(reputation);
    });
  }
  window.HolyFooterV4 = { init: init };
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

(function () {
  function labelIumyLogo() {
    document.querySelectorAll('.iumy-powered img:not([alt]), img[src*="logo-iumy.png"]:not([alt])').forEach(function (image) {
      image.alt = 'Iumy';
    });
  }
  labelIumyLogo();
  document.addEventListener('DOMContentLoaded', labelIumyLogo, { once: true });
  window.addEventListener('load', labelIumyLogo, { once: true });
  [1000, 3000, 6000].forEach(function (delay) { window.setTimeout(labelIumyLogo, delay); });
})();
